import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  noResultsContainerStyles,
  noResultsSuggestionStyles,
  noResultsTitleStyles,
} from '../../../../UniversalSearch.styles';
import { SEARCH_SUGGESTIONS } from '../../SearchResults.constants';

const NoResults = ({ query }) => (
  <Box sx={noResultsContainerStyles}>
    <Typography sx={noResultsTitleStyles} variant="medium14">
      {`No results for "${query}"`}
    </Typography>
    <Typography sx={noResultsSuggestionStyles} variant="regular12">
      {SEARCH_SUGGESTIONS[Math.floor(Math.random() * SEARCH_SUGGESTIONS.length)]}
    </Typography>
  </Box>
);

NoResults.propTypes = {
  query: PropTypes.string.isRequired,
};

export default NoResults;
